var exports = {
  "lm": "ThreadComposerArea.module__notice___VTRwbn",
  "EP": "ThreadComposerArea.module__noticeIcon___VTRwbn",
  "ut": "ThreadComposerArea.module__noticeText___VTRwbn",
  "Sx": "ThreadComposerArea.module__lockedIcon___VTRwbn",
};

module.exports = exports;
